import { all } from "redux-saga/effects";

import * as Saga from "../sagas";

export default function* watch() {
  const watchAllSaga = Object.values(Saga).map((saga) => {
    return saga.Watcher();
  });
  yield all(watchAllSaga);
}
